"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Check = function Check(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5742,2.128906 C17.6601,2.0429686 17.7747,2 17.9179,2 C18.0612,2 18.1901,2.0429686 18.3046,2.128906 L19.5078,3.375 C19.6224,3.46093 19.6796,3.57552 19.6796,3.71875 C19.6796,3.86197 19.6224,3.99088 19.5078,4.10546 L6.61717,16.9961 C6.53123,17.082 6.41665,17.125 6.27342,17.125 C6.13019,17.125 6.00129,17.082 5.8867,16.9961 L0.171875,11.23826 C0.0572913,11.15232 0,11.03774 0,10.89451 C0,10.75128 0.0572913,10.62238 0.171875,10.50779 L1.375,9.30467 C1.48958,9.19009 1.61849,9.1328 1.76171,9.1328 C1.90494,9.1328 2.01953,9.19009 2.10546,9.30467 L6.27342,13.4726 L17.5742,2.128906 Z",
    id: "check"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#check"
  }));
};

var _default = Check;
exports["default"] = _default;
module.exports = exports["default"];